import { DeleteOutlined } from '@ant-design/icons';
import { Col, Form, Row } from 'antd';
import { useState } from 'react';
import CustomButton from '../../../v2-components/Antd/Button';
import CustomCard from '../../../v2-components/Antd/Card';
import CustomDivider from '../../../v2-components/Antd/Divider';
import CustomFormItem from '../../../v2-components/Antd/FormItem';
import CustomImage from '../../../v2-components/Antd/Image';
import CustomInput from '../../../v2-components/Antd/Input';
import CustomLink from '../../../v2-components/Antd/Link';
import CustomModal from '../../../v2-components/Antd/Modal';
import CustomTable from '../../../v2-components/Antd/Table';
import LoadingModal from '../../../v2-components/LoadingModal';
import { CustomNotification } from '../../../v2-components/Notification';
import SearchComponent from '../../../v2-components/Search';
import useSearchStore from '../../../v2-components/Search/store/useSearchStore';
import { nameAdapter } from './handle/name-adapter.handle';
import { Service } from './service';
import { useAdminCarouselStore } from '../store/useCarouselStore';
import './style.scss';

import CustomUpload from '../../../v2-components/Antd/Upload';
import * as XLSX from 'xlsx';
import { platformNames } from '../constants/platform-names.contants';

export default function CarouselCreateAdminPage() {
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [selectedRowKeys, setSelectedRowKeys] = useState([]);
	const [setProducts, products, addProducts] = useSearchStore((state) => [state.setProducts, state.products, state.addProducts]);
	const [root_pharmacy, currentInfo, data, originProducts, pharmacy, platform, setOriginProducts, setCurrentInfo, setData] = useAdminCarouselStore(
		(state) => [
			state.root_pharmacy,
			state.currentInfo,
			state.data,
			state.originProducts,
			state.pharmacy,
			state.platform,
			state.setOriginProducts,
			state.setCurrentInfo,
			state.setData,
		],
	);
	const [skuGroup, setSkuGroup] = useState(null);
	const [loading, setLoading] = useState(false);
	const [form] = Form.useForm();

	const [fileList, setFileList] = useState([]);

	const handleDeleteProduct = (sku) => {
		const filteredProducts = products.filter((product) => product.sku !== sku);
		setProducts(filteredProducts);
	};

	const handleDeleteSelectedProducts = () => {
		const filteredProducts = products.filter((product) => !selectedRowKeys.includes(product.sku));
		setProducts(filteredProducts);
	};
	const handleDeleteAllProducts = () => {
		setProducts([]);
	};

	const handleInputChange = (e) => {
		setSkuGroup(e.target.value);
	};

	const handleAddMultipleProducts = () => {
		setLoading(true);
		setSkuGroup('');
		new Service()
			.getProducts(skuGroup)
			.then((response) => {
				if (response.statusCode === 404) {
					CustomNotification({ type: 'error', message: response.message, description: 'No hubo coincidencias con los sku ingresados' });
					setLoading(false);
					setIsModalOpen(false);
				}
				if (response.statusCode === 500) {
					CustomNotification({ type: 'error', message: 'Error', description: 'Verifique los datos ingresados e intente nuevamente' });
					setLoading(false);
					setIsModalOpen(false);
				}
				addProducts(response);
				setLoading(false);
				setIsModalOpen(false);
				setFileList([]);
			})
			.catch((error) => {
				CustomNotification({ type: 'error', message: 'Error', description: 'Error del servidor.Consulte a soporte' });
				setIsModalOpen(false);
			});
	};

	const columns = [
		{
			dataIndex: 'sku',
		},
		{
			dataIndex: 'editable_name',
		},
		{
			dataIndex: 'laboratory',
			render: (record) => `Laboratorio ${record}`,
		},
		{
			dataIndex: 'action',
			render: (_, record) => (
				<CustomButton
					style={{ border: 'none', backgroundColor: 'transparent' }}
					icon={<DeleteOutlined />}
					onClick={() => handleDeleteProduct(record.sku)}
				/>
			),
		},
	];

	const rowSelection = {
		selectedRowKeys,
		onChange: (newSelectedRowKeys) => {
			setSelectedRowKeys(newSelectedRowKeys);
		},
		getCheckboxProps: (record) => ({
			disabled: record.name === 'Disabled User',
			name: record.name,
		}),
	};

	const handleSaveProducts = () => {
		setLoading(true);
		const editable_name = form.getFieldValue('editable_name');
		const productsId = products.map((product) => product.sku);
		const updatedBody = { products: productsId, editable_name };
		new Service()
			.updateProducts(updatedBody, currentInfo._id)
			.then((response) => {
				console.log('response', response);
				const currentInfoUpdated = { ...currentInfo };
				currentInfoUpdated.products = response.products;
				currentInfoUpdated.editable_name = response.editable_name;
				const dataToUpdate = data;
				const dataIndexToUpdate = data.findIndex((carousel) => carousel._id === currentInfoUpdated._id);
				if (dataIndexToUpdate !== -1) {
					dataToUpdate[dataIndexToUpdate] = currentInfoUpdated;
				}
				setCurrentInfo(currentInfoUpdated);
				setOriginProducts(products);
				setData(dataToUpdate);
				setLoading(false);
				CustomNotification({ type: 'success', message: 'Éxito', description: 'Los productos fueron guardados correctamente.' });
			})
			.catch((error) => console.log('error', error));
	};

	console.log('selectedRowKeys', selectedRowKeys);

	const handleFileUpload = (file) => {
		const reader = new FileReader();
		reader.onload = (e) => {
			const data = new Uint8Array(e.target.result);
			const workbook = XLSX.read(data, { type: 'array' });
			const firstSheetName = workbook.SheetNames[0];
			const worksheet = workbook.Sheets[firstSheetName];
			const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
			const ids = jsonData.map((row) => row[0]); // Assuming the first column contains the IDs
			setSkuGroup(ids);
			console.log('Extracted IDs:', ids);
			// You can now use the extracted IDs as needed
		};
		reader.readAsArrayBuffer(file);
		return false; // Prevent automatic upload
	};
	const handleRemoveFile = (file) => {
		setFileList((prevList) => prevList.filter((item) => item.uid !== file.uid));
	};

	return (
		<>
			<div className="landing-product-list-container">
				<h1>Crear</h1>
				<CustomLink to={`/admin-carousel/detail`}>{`Volver a ${nameAdapter(root_pharmacy)} / ${
					data?.length > 1 || platform === platformNames.ecc ? 'Home' : `Corner ${pharmacy.toUpperCase()}`
				} / Carrousel
				`}</CustomLink>
				<Row gutter={60} style={{ marginTop: '20px' }}>
					<Col md={16}>
						<CustomCard title={'Datos del modulo'}>
							<Form
								form={form}
								initialValues={{
									root_pharmacy: nameAdapter(data[0]?.root_pharmacy),
									page: data?.length > 1 || platform === platformNames.ecc ? 'Home' : `Corner ${pharmacy.toUpperCase()}`,
									module: 'Carrousel',
									editable_name: currentInfo?.editable_name,
								}}
								className="create-form"
							>
								<Row gutter={16}>
									<Col md={8}>
										<CustomFormItem name={'root_pharmacy'} label={'Plataforma'}>
											<CustomInput disabled={true} />
										</CustomFormItem>
									</Col>
									<Col md={8}>
										<CustomFormItem name={'page'} label={'Página'}>
											<CustomInput disabled={true} />
										</CustomFormItem>
									</Col>
									<Col md={8}>
										<CustomFormItem name={'module'} label={'Módulo'}>
											<CustomInput disabled={true} />
										</CustomFormItem>
									</Col>
									<Col md={24}>
										<CustomFormItem name={'editable_name'} label={'Titulo carrousel (visible en la web)'}>
											<CustomInput />
										</CustomFormItem>
									</Col>
								</Row>
								<h2>Carga de productos</h2>
								<Row gutter={12} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
									<Col md={21}>
										<SearchComponent />
									</Col>
									<Col>
										<h3 onClick={() => setIsModalOpen(true)} style={{ color: '#0a6dc2', cursor: 'pointer' }}>
											Carga masiva
										</h3>
									</Col>
									<Col md={24} style={{ marginTop: '10px' }}>
										<div>
											<CustomTable
												locale={{ emptyText: 'Aún no has agregado productos a la lista.' }}
												rowKey="sku"
												rowSelection={{
													type: 'checkbox',
													...rowSelection,
												}}
												columns={columns}
												dataSource={products}
												showHeader={false}
												pagination={{ position: ['bottomLeft'], pageSize: 5, showSizeChanger: false }}
											/>
											<div style={{ display: 'flex', justifyContent: 'right' }}>
												<CustomButton
													onClick={handleDeleteSelectedProducts}
													type="link"
													disabled={selectedRowKeys.length === 0}
													style={{ cursor: 'pointer' }}
												>
													Eliminar seleccionados
												</CustomButton>
												<CustomButton onClick={handleDeleteAllProducts} type="link" style={{ cursor: 'pointer' }}>
													Eliminar todos
												</CustomButton>
											</div>
										</div>
									</Col>
								</Row>
								<div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '10px' }}>
									<CustomButton
										onClick={() => {
											setProducts(originProducts);
											form.resetFields();
										}}
									>
										CANCELAR
									</CustomButton>
									<CustomButton onClick={handleSaveProducts} style={{ marginLeft: '10px' }}>
										GUARDAR
									</CustomButton>
								</div>
							</Form>
						</CustomCard>
					</Col>
					<Col md={8}>
						<CustomCard
							style={{ width: '500px', height: '650px', cursor: 'pointer', textAlign: 'center', alignItems: 'center', display: 'flex' }}
						>
							<CustomImage
								width={'60%'}
								preview={false}
								src={'https://storage.googleapis.com/tirx-resources-production/6c5f1634-3050-4abd-b943-34523b61bd47.webp'}
								alt="img"
							/>
						</CustomCard>
					</Col>
				</Row>
				<CustomModal
					title="Carga másiva de productos por SKU"
					width={700}
					open={isModalOpen}
					centered
					onCancel={() => setIsModalOpen(false)}
					footer={[
						<CustomButton
							key="cancel"
							type="primary"
							disabled={loading}
							onClick={() => {
								setIsModalOpen(false);
								setSkuGroup('');
								setFileList([]);
							}}
						>
							Cancelar
						</CustomButton>,
						<CustomButton disabled={loading} key="ok" type="primary" onClick={handleAddMultipleProducts}>
							Guardar
						</CustomButton>,
					]}
				>
					<CustomDivider />
					<p>El listado a pegar debe contener solo SKU separados por , (coma) y al guardar se sumara a la lista de productos.</p>
					<p>En caso de subir los sku desde archivo revisar que solo haya una fila de sku sin cabeceras.</p>
					<p>Lista de SKU</p>
					<CustomInput placeholder={'1,2,3,4,5,6...'} value={skuGroup} type={'text'} onChange={handleInputChange} />
					<CustomUpload
						beforeUpload={handleFileUpload}
						accept=".xlsx"
						onRemove={handleRemoveFile}
						fileList={fileList}
						onChange={({ fileList: newFileList }) => setFileList(newFileList)}
					>
						<CustomButton style={{ marginTop: '20px' }} type="primary">
							Cargar SKUS desde archivo
						</CustomButton>
					</CustomUpload>
					<CustomDivider />
				</CustomModal>
				<LoadingModal visible={loading} />
			</div>
		</>
	);
}
